export default __webpack_public_path__ + "static/media/chat.594ee26b.svg";